import React, { Component, Fragment } from 'react';

import ToolTip from '../../tooltip';
import { NavItem, NavList } from './styled';
class Nav extends Component {
    static defaultProps = {
        horizontal: false,
        showTitle: false,
        titlePosition: 'left',
        activeSelector: 'link',
    }

    render() {
        const { horizontal, navList, dotSize, fill, active, showTitle, titlePosition, activateMenu, activeSelector, ...props } = this.props;

        const renderNavItem = (item) => (
            <NavItem
                dotSize={dotSize}
                active={active && item[activeSelector] === active[activeSelector]}
                fill={fill}
                onClick={() => activateMenu(item)}
                data-test='nav-item'
            />
        );

        return (
            <NavList horizontal={horizontal} {...props}>
                {navList.map((item, index) => (
                    <Fragment key={index}>
                        {showTitle
                            ? <ToolTip
                                stateful={true}
                                parent={
                                    renderNavItem(item)
                                }
                                position={titlePosition}
                                arrow='center'
                            >
                                {item.title}
                            </ToolTip>
                            : renderNavItem(item)
                        }
                    </Fragment>
                ))}
            </NavList>
        );
    }
}

export default Nav;
